import { useRedirectOnSuccess } from "@/src/mixins/useRedirectOnSuccess";
import {
  fetchStream,
  toCamelCase,
  toTitleCase,
  windowURL,
} from "@/src/utils/common";
import FormWatcher from "@/src/utils/form-watcher";
import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["container", "add"];

  connect() {
    this.formWatcher = new FormWatcher(this.containerTarget);
    this.element[toCamelCase(this.identifier)] = this;
    useRedirectOnSuccess(this);
  }

  input(event) {
    const { currentTarget } = event;
    const { formId: currentFormId } = currentTarget.closest("[data-form-id]").dataset;
    const newFormId = currentTarget.dataset.mediaProviderId;

    if (currentFormId && newFormId && currentFormId !== newFormId) {
      currentTarget.closest("[data-form-id]").setAttribute("data-form-id", newFormId);
      this.formWatcher.updateInstanceId(currentFormId, newFormId);
    }

    this.formWatcher.reconcile(
      currentTarget,
      (instanceField) => {
        currentTarget.setAttribute("name", instanceField.identifier);
      },
      () => {
        currentTarget.removeAttribute("name");
      }
    );
  }

  add(_e, name) {
    const dummy = document.createElement("span");
    dummy.id = "dummy-target";
    dummy.className = "hidden";
    this.addTarget.after(dummy);

    fetchStream(
      "GET",
      `${windowURL}/new`,
      {
        target: dummy.id,
        name: name ?? ""
      },
      (content) => this.formWatcher.collect(content)
    );
  }

  addFromRene(e) {
    const { mediaProviderName } = e.currentTarget.dataset;
    this.add(undefined, mediaProviderName);
    e.target.innerHTML = "Added"
    const row = e.target.closest("tr");
    row.classList.add("disabled");
  }

  delete(event) {
    const { currentTarget } = event;
    const box = currentTarget.closest(".box");
    const { formModel, formId } = box.dataset;
    box.querySelectorAll("[data-form-field]").forEach((field) => {
      field.setAttribute(
        "name",
        `delete_params[${toTitleCase(formModel)}][${formId}]`
      );
    });
    box.classList.add("fade-out");
    setTimeout(() => box.classList.add("hidden"), 300);
  }
}
